import { useApi } from "./useApi";
import { Events, dispatch } from "../redux/dispatch";

export const useCodes = () => {
  const { client } = useApi();
  const notifyError = (message = "No fue posible obtener los códigos.") => {
    dispatch(Events.SHOW_ALERT, {
      message,
      type: "ERROR",
    });
  };

  const getCodes = async () => {
    try {
      const codes = await client.get("/v1/codes");
      return codes;
    } catch (err) {
      notifyError();
    }
  };

  const validateCode = async (code) => {
    try {
      return await client.get(`/v1/code/${code}`);
    } catch (err) {
      notifyError("No fue posible validar el código.");
      return null;
    }
  };

  return { getCodes, validateCode };
};
